import { fetchData, apiURL } from './api_helper';

const userByEmail = email => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/user-by-email/${email}`;
  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result.response);
  }).catch((error) => {
    reject(error);
  });
}));

const authWithDKTSSO = data => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/dkt/users`;
  fetchData(endpointURL, 'POST', data, false).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error.response);
  });
}));

const authWithSocialNetwork = credentials => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users`;
  fetchData(endpointURL, 'POST', credentials).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const updateUser = metaData => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/me`;
  fetchData(endpointURL, 'PUT', metaData).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error.response);
  });
}));

const registerWithEmail = regData => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users`;
  fetchData(endpointURL, 'POST', regData).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error.response);
  });
}));

const loginWithEmail = loginData => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/login`;
  fetchData(endpointURL, 'POST', loginData).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error.response);
  });
}));

const loginWithFacebook = credential => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/login/facebook`;
  fetchData(endpointURL, 'POST', credential).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error.response);
  });
}));

const loginWithGoogle = credential => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/login/google`;
  fetchData(endpointURL, 'POST', credential).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error.response);
  });
}));

const loginWithApple = credential => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/login/apple`;
  fetchData(endpointURL, 'POST', credential).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error.response);
  });
}));

const registerDevice = data => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/me/registerDevice`;
  fetchData(endpointURL, 'POST', data).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error.response);
  });
}));

const generatePasswordReset = email => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/generatePasswordReset`;
  fetchData(endpointURL, 'POST', email).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error.response);
  });
}));

const resetPassword = passwordData => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/resetPassword`;
  fetchData(endpointURL, 'POST', passwordData).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const getLoggedInUserProfile = () => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/me`;
  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const deleteUserProfile = email => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/me`;
  fetchData(endpointURL, 'DELETE').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const deleteAvatar = () => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/me/removeProfilePicture`;
  fetchData(endpointURL, 'DELETE').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const uploadAvatar = blob => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/me/uploadProfilePicture`;
  fetchData(endpointURL, 'FILE', blob).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error.response);
  });
}));

const changePassword = passwords => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/me/changePassword`;
  fetchData(endpointURL, 'POST', passwords).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error.response);
  });
}));

const changedPushNotificationStatus = data => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/notification_status_change/${data.notificationId}`;
  fetchData(endpointURL, 'get').then((result) => {
    resolve(result.response);
  }).catch((error) => {
    reject(error);
  });
}));

const getUsageStatistics = () => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/me/usageStatistics`;
  fetchData(endpointURL, 'get').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const getSyncStatusPoll = () => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/dkt/users/syncStatus/poll`;
  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error.response);
  });
}));

const idpKeepSignIn = () => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/keepSignIn`;
  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error.response);
  });
}));

const idpLogOut = () => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/me/logout`;
  fetchData(endpointURL, 'POST').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error.response);
  });
}));

const createTeacherStatistics = value => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/teacherStatistics`;
  fetchData(endpointURL, 'POST', value).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error.response);
  });
}));

export default {
  userByEmail,
  authWithDKTSSO,
  authWithSocialNetwork,
  updateUser,
  registerWithEmail,
  loginWithEmail,
  loginWithFacebook,
  loginWithGoogle,
  loginWithApple,
  registerDevice,
  generatePasswordReset,
  resetPassword,
  getLoggedInUserProfile,
  deleteUserProfile,
  deleteAvatar,
  uploadAvatar,
  changePassword,
  changedPushNotificationStatus,
  getUsageStatistics,
  getSyncStatusPoll,
  idpKeepSignIn,
  idpLogOut,
  createTeacherStatistics
};



// WEBPACK FOOTER //
// ./src/api/users.js